import { contactService } from '../../helpers/services/contact.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  pagination: {},
  status: { list: true, save: true },
  lastError: null,
}

export const CONTACT_MODULE = 'contact'

export const GET_CONTACTS = 'getContacts'
export const CREATE_CONTACT = 'createContact'
export const UPDATE_CONTACT = 'updateContact'
export const DELETE_CONTACT = 'deleteContact'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'

export const actions = {
  [GET_CONTACTS]({ commit }, { filter } = {}) {
    commit(REQUESTING, 'list')
    return contactService.getAll(filter || {}).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e)
    })
  },
  [CREATE_CONTACT]({ commit }, { payload }) {
    commit(REQUESTING, 'save')
    return contactService.create(payload).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return null
    })
  },
  [UPDATE_CONTACT]({ commit }, { uuid, payload }) {
    commit(REQUESTING, 'save')
    return contactService.update(uuid, payload).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return null
    })
  },
  [DELETE_CONTACT]({ commit }, { uuid }) {
    commit(REQUESTING, 'save')
    return contactService.remove(uuid).then(() => {
      commit(SUCCESS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE, e); return false
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list = data?.data || []
    state.pagination = data?.pagination || {}
  },
  [FAILURE](state, error) {
    state.status = { list: true, save: true }
    state.lastError = error || null
  },
  [REQUESTING](state, type) {
    state.status[type] = false
    state.lastError = null
  },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
